package com.happyukrainian.revision.kweb.pages.routes

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import practicetest.Subject

@Composable
fun BoxScope.SubjectRoute(
    subjects: List<Subject>,
    onSubjectSelected: (Subject) -> Unit
) {
    if (subjects.isEmpty()) {
        SpanText("Loading...")
    } else {
        SimpleGrid(
            numColumns = numColumns(2),
            modifier = Modifier
                .fillMaxWidth()
                .height(100.vh)
                .padding(topBottom = 2.vh, leftRight = 2.vw)
                .alignContent(AlignContent.Center)
        ) {
            subjects.forEach { subject ->
                Box(
                    modifier = Modifier
                        .margin(2.vw)
                        .background(
                            Background.of(
                                image = CSSImage.of(url("https://happyukrainian.com/user/pages/02.subjects/${subject.key}/${subject.key}.png")),
                                size = BackgroundSize.Cover,
                                position = BackgroundPosition.of(
                                    CSSPosition.Center
                                )
                            ),
                            Background.of(
                                CSSImage.of(
                                    linearGradient(
                                        dir = LinearGradient.Direction.ToBottom
                                    ) {
                                        add(Color("#054D7F2c"), 0.percent)
                                        add(Color("#054D7Fcc"), 75.percent)
                                    }
                                )
                            )
                        )
                        .borderRadius(20.px)
                        .height(min(40.vh, 60.vw))
                        .aspectRatio(261.0f / 473.0f)
                        .onClick {
                            onSubjectSelected(subject)
                        }
                ) {

                    SpanText(
                        text = subject.name,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(32.px)
                            .color(Color.white)
                            .textAlign(TextAlign.Center)
                            .fontSize(min(2.8.vw, 2.8.vh))
                            .align(Alignment.BottomCenter)
                    )
                }
            }
        }
    }
}